import { css } from 'styled-components';
var getSelectStyle = function getSelectStyle(props) {
  return css([".c7n-pro-select-popup{.c7n-pro-select-dropdown-menu.c7n-pro-select-dropdown-menu{padding-left:0;padding-right:0;}}"]);
};
var selectData = {
  name: 'select',
  data: [{}],
  // 开启模板融合
  fusionTemplate: true,
  onlyTemplate: {
    pro: getSelectStyle
  }
};
export default selectData;